import { Pipe, PipeTransform } from '@angular/core';
import { CnpjUtils } from '../../shared/utils/cnpj-utils';

@Pipe({
  name: 'cnpj',
})
export class CnpjPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) return value;
    return CnpjUtils.formatWithMaskOrDefault(value) || value;
  }
}
